import type { ChipProps } from "@mui/material";
import type { DocumentRowUi } from "../types/documentManagementUiTypes";
import { resolveLifecycleStatus } from "../services/ragDocumentApi";

export function uploadStatusChipColor(
  uploadStatus: string,
  lifecycleStatus?: string
): ChipProps["color"] {
  const normalized = lifecycleStatus || resolveLifecycleStatus({ upload_status: uploadStatus });
  if (normalized === "processed") {
    return "success";
  }
  if (normalized === "failed" || normalized === "rolled_back") {
    return "error";
  }
  if (normalized === "processing") {
    return "info";
  }
  if (normalized === "uploaded") {
    return "default";
  }
  return "default";
}

export function uploadStatusChipLabel(
  uploadStatus: string,
  lifecycleStatus?: string
): string {
  const normalized = lifecycleStatus || resolveLifecycleStatus({ upload_status: uploadStatus });
  if (normalized === "rolled_back") {
    return "Rolled back";
  }
  if (normalized === "processed") {
    return "Processed";
  }
  if (normalized === "failed") {
    return "Failed";
  }
  if (normalized === "processing") {
    return "Processing";
  }
  return uploadStatus;
}

export function formatProductModelLine(row: DocumentRowUi): string {
  const product = row.product_name?.trim() || "";
  const model = row.model_name?.trim() || "";
  if (product && model) {
    return `${product} / ${model}`;
  }
  if (product) {
    return product;
  }
  if (model) {
    return model;
  }
  return "—";
}
